.productInfoDesc {
  text-align: left;
  margin-right: auto;
}

.productInfoShortView {
  font-size: var(--product-block-font-size);
  text-decoration: none;
  display: block;
  word-break: break-word;
  margin-bottom: 0.5rem;
}
